export default __webpack_public_path__ + "static/media/Hindi_af_1.b2449bbd.mp3";